import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CONTROL_EVENT } from '../core/models/events_promotion';
import { environment } from 'src/environments/environment.prod';
import { RequestValidProductByStore } from '../core/models/request';
import { ResponseGralInt } from '../core/models/response_gral';

@Injectable({
  providedIn: 'root'
})
export class PromotionPageService {

  private URL;

  public isPromocion = false;
  public functionEventAction = new BehaviorSubject<CONTROL_EVENT | null>(null);
  constructor(
    private http: HttpClient
  ) {
    this.URL = environment.domain
    this.initByUrl()
  }

  initByUrl() {
    let paths: any[] = location.pathname.split('/');
    if (paths.length > 1 && paths[4] && paths[5]) {
      if (paths[4] == 'PD') {

      }
      if (paths[5] == "promotion") {
        console.log("promotion")
        this.isPromocion = true
      }
    }
  }

  verifiedUrl() {
    if (this.isPromocion == false) {
      this.initByUrl()
    }
  }

  onSentAction(eve: CONTROL_EVENT) {
    this.functionEventAction.next(eve)
  }

  //SERVICIO QUE ME VALIDA EL PRODUCTO POR TIENDA
  async validateProductByStore(req: RequestValidProductByStore): Promise<ResponseGralInt> {
    const url_api = this.URL + 'api/em/material/validate_item';
    let res: ResponseGralInt;
    try {
      res = await this.http.post<any>(url_api, req).toPromise()
    } catch (error) {
      res = {
        data: null,
        message: "Ocurrio un error al consultar",
        response: "error"
      }
    }
    return res;
  }
}
